import React, { useState } from "react";
import { Redirect } from "react-router-dom";

const DateDent = (props) => {
  const initialStateValues = {
    car_brand: "",
    car_model: "",
    car_year: '',
    dent_place: "",
    additional_notes: "",
    redirectToHome: false,
  };

  const [valores, setValores] = useState(initialStateValues);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValores({ ...valores, [name]: value });

    var f = document.forms["theform"].elements;
    var cansubmit = true;

    for (var i = 0; i < f.length; i++) {
      if (f[i].value.length === 0) cansubmit = false;
    }

    if (cansubmit) {
      document.getElementById("submitbutton").disabled = false;
    } else {
      document.getElementById("submitbutton").disabled = "disabled";
    }
  };

  const hundleSubmit = (e) => {
    e.preventDefault();
    sessionStorage.setItem("car_brand", valores.car_brand);
    sessionStorage.setItem("car_model", valores.car_model);
    sessionStorage.setItem('car_year', valores.car_year);
    sessionStorage.setItem("dent_place", valores.dent_place);
    sessionStorage.setItem("additional_notes", valores.additional_notes);
    setValores({
      redirectToHome: true,
    });
  };
  return (
    <div className="contenedor  mx-auto mt-4">
      {valores.redirectToHome ? <Redirect push to="/photos" /> : null}
      <form name="theform" onSubmit={hundleSubmit}>
        <div className="form-group">
          <label className="d-block text-center">Make</label>
          <input
            name="car_brand"
            onChange={handleInputChange}
            value={valores.car_brand || ""}
            type="text"
            placeholder="Ex. Ford"
          />
        </div>
        <div className="form-group">
          <label className="d-block text-center">Model</label>
          <input
            name="car_model"
            onChange={handleInputChange}
            value={valores.car_model || ""}
            type="text"
            placeholder="Ex. F150"
          />
        </div>
        <div className="form-group">
          <label className="d-block text-center">Year</label>
          <input
            name="car_year"
            onChange={handleInputChange}
            value={valores.car_year || ""}
            type="text"
            placeholder="Ex. 2019"
          />
        </div>
        <div className="form-group">
          <label
            className="d-block text-center"
            htmlFor="exampleFormControlSelect1"
          >
            Where is the dent? Please select one at a time.
          </label>
          <select
            id="exampleFormControlSelect1"
            name="dent_place"
            onChange={handleInputChange}
            value={valores.dent_place || ""}
          >
            <option value="">Please, select a option</option>
            <option>Hood</option>
            <option>Driver side front fender</option>
            <option>Passenger side front fender</option>
            <option>Driver side front door</option>
            <option>Passenger side front door</option>
            <option>Driver side rear door</option>
            <option>Passenger side rear door</option>
            <option>Roof</option>
            <option>Driver side rear quarter panel</option>
            <option>Passenger side rear quarter panel</option>
            <option>Front bumper</option>
            <option>Rear bumper</option>
            <option>Trunk</option>
            <option>Other/I’m not sure</option>
          </select>
        </div>
        <label className="d-block text-center">Additional notes</label>
        <div className="form-group">
        <textarea
          type="text"
          name="additional_notes"
          onChange={handleInputChange}
          value={valores.additional_notes || ""}
        />
        </div>
        <div className=" text-center mt-5 mb-5">
          <button
            id="submitbutton"
            type="submit"
            disabled="disabled"
            value="Submit"
            onClick={hundleSubmit}
            className="btn btn-secondary mx-auto mb-5 mt-2"
          >
            Next step
          </button>
        </div>
      </form>
    </div>
  );
};
export default DateDent;
